import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import swal from 'sweetalert2';
import { EditTrackerService } from '../../../core/services/edit-tracker.service';
import { FeatureService, PermissionService } from '../../../core/services/permission';
import { RepoEstimatesService } from '../../../data/repositories/repo-estimates.service';
import { JobsService } from '../../jobs/jobs.service';

@Component({
    selector: 'menubar-jobs',
    templateUrl: './menubar.jobs.component.html',
    standalone: false,
})
export class MenubarJobsComponent {
    @Input() currentState: any;
    @Input() currentStateParams: any;
    @Input() job: any;
    // @ts-ignore TS2564
    @Input() active: boolean;
    @Input() estimate: any;
    @Output() itemClick = new EventEmitter();

    constructor(
        public permissionService: PermissionService,
        public featureService: FeatureService,
        private jobsService: JobsService,
        private editTrackerService: EditTrackerService,
        private estimateRepo: RepoEstimatesService
    ) {
        this.jobsService = jobsService;
        this.editTrackerService = editTrackerService;
    }

    createJob() {
        if (this.editTrackerService.isTracking && this.editTrackerService.form && !this.editTrackerService.allowStateChange) {
            swal.fire({
                icon: 'warning',
                title: 'Unsaved Changes',
                text: 'You have not finished editing a form. Please save changes before creating a job.',
                customClass: { popup: 'bx-dialog  bx-dialog-warning' },
                allowOutsideClick: false,
                animation: false,
            });
        } else {
            this.estimateRepo.GetIfNewerVersion(this.estimate).then((estimate) => {
                this.jobsService.newJob({}, estimate).catch(() => ({}));
            });
        }
    }

    // @ts-ignore TS7006
    onChangeRoute($event, route, params) {
        $event.preventDefault();
        this.itemClick.emit({ $event, route, params });
    }
}

@NgModule({
    declarations: [MenubarJobsComponent],
    imports: [CommonModule, TranslateModule],
    exports: [MenubarJobsComponent],
})
export class MenubarJobsModule {}
